module.exports = __webpack_public_path__ + "media/images/reportimages/conversation-79ba39dd77c605d45bd0af69f03e3358.png";